import { api } from '../api'
import type { Brand, BrandsFilters, BrandsResponse, MemberDetail, MembersFilters, MembersResponse } from '../../types/organization.types'

export const getMemberDetails = async (id: string): Promise<MemberDetail> => {
  const res = await api.get<MemberDetail>(`members/${id}/`)
  return res.data
}

export const getBrandDetails = async (id: string): Promise<Brand> => {
  const res = await api.get<Brand>(`members/brands/${id}/`)
  return res.data
}

export const getBrands = async (params: BrandsFilters): Promise<BrandsResponse> => {
  const res = await api.get<BrandsResponse>('members/brands/', {
    params: { ...params, ordering: 'name' },
  })
  return res.data
}

export const getMembers = async (params: MembersFilters): Promise<MembersResponse> => {
  const res = await api.get<MembersResponse>('members/', { params })
  return res.data
}
